// REACT
import { useState } from "react";

// MATERIAL-UI
import { Grid, Button, Typography } from "@mui/material";

// COMPONENTS
import CountryOrCryptoFlag from "src/components/common/CountryOrCryptoFlag";
import { BottomDrawer } from "../dropdown/BottomDrawer";

// ASSETS
import { setSelectedCurrency } from "src/store/features/settings.slice";
import { RootState, useAppDispatch, useAppSelector } from "src/store/store";
import { HeaderStyles } from "../common/styles/Header.styles";
import { walletDrawerstyles } from "../common/styles/WalletDrawer.styles";
import GA from "src/analytics/googleAnalytics";
import { FIAT_CURRENCIES, CRYPTO_DENOMINATIONS } from "src/utils/constants";
import Title from "src/components/common/Title";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
//
// MOBILE COMPONENT
//

export default function WalletHeaderMobile() {
  const classes = HeaderStyles();
  const styles = walletDrawerstyles();

  // redux - get users selected currency
  const { selectedCurrency } = useAppSelector((state: RootState) => state.settings);
  const reduxDispatch = useAppDispatch();
  const [fiatOpen, setFiatOpen] = useState<boolean>(false);
  const handleClose = (): void => {
    setFiatOpen(false);
  };

  const handleCurrencySelection = (event: any, type: string) => {
    reduxDispatch(setSelectedCurrency(type));
    GA.currencySelection(type);
    setFiatOpen((prev) => !prev);
  };

  const fiatConfig = {
    drawerOpen: fiatOpen,
    drawerClose: handleClose,
    subtitle: "Select Currency",
    fiat: [...CRYPTO_DENOMINATIONS, ...FIAT_CURRENCIES],
    searchable: false,
    onClick: handleCurrencySelection,
    drawerStyles: {
      disabled: false,
      borderRadius: "12px 12px 0px 0px",
      height: "70%",
    },
  };

  return (
    <>
      <Grid container item xs={4} style={{ marginBottom: "20px" }}>
        <Grid item xs={4}>
          <div style={{ display: "flex" }}>
            <Typography className={classes.title}>Holdings</Typography>
            <Button
              id="wallet-currency-button"
              disableRipple
              sx={{
                "& .MuiButton-endIcon": {
                  marginLeft: "0px",
                },
                "& .MuiButton-startIcon": {
                  marginRight: "0px",
                },
              }}
              endIcon={<KeyboardArrowDownIcon sx={{ marginLeft: "0px" }} />}
              startIcon={<CountryOrCryptoFlag name={selectedCurrency} size={24} />}
              className={styles.Button}
              onClick={() => setFiatOpen(true)}></Button>
          </div>
        </Grid>
        <BottomDrawer config={fiatConfig} />
      </Grid>
    </>
  );
}

//
// DESKTOP COMPONENT
//

export function WalletHeaderDesktop() {
  const classes = HeaderStyles();
  return (
    <Grid container alignItems="center">
      <Grid item xs={4} md={4}>
        <Title title={{ partB: "Holdings" }} />
      </Grid>
      <Grid
        item
        xs={8}
        md={8}
        justifyContent="flex-end"
        alignItems="end"
        className={classes.iconCurrencyContainer}></Grid>
    </Grid>
  );
}
